var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5789 7H18C19.2281 7 20 7.77193 20 9V16C20 17.2281 19.2281 18 18 18H6C4.77193 18 4 17.2281 4 16V7C4 5.77193 4.77193 5 6 5H9.57895L11.5789 7ZM9.29825 4.70175L11.2982 6.70175C11.4737 6.89474 11.7193 7 12 7C12.5439 7 13 6.54386 13 6C13 5.7193 12.8947 5.47368 12.7018 5.29825L10.7018 3.29825C10.5263 3.10526 10.2807 3 10 3C9.45614 3 9 3.45614 9 4C9 4.2807 9.10526 4.52632 9.29825 4.70175ZM12 7H18C19.2281 7 20 7.77193 20 9V16C20 17.2281 19.2281 18 18 18H6C4.77193 18 4 17.2281 4 16V7C4 5.77193 4.77193 5 6 5H10C10.5439 5 11 4.54386 11 4C11 3.45614 10.5439 3 10 3H6C3.78947 3 2 4.78947 2 7V16C2 18.2105 3.78947 20 6 20H18C20.2105 20 22 18.2105 22 16V9C22 6.78947 20.2105 5 18 5H12C11.4561 5 11 5.45614 11 6C11 6.54386 11.4561 7 12 7Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.edaa4ede.svg";
export { ForwardRef as ReactComponent };